import { Component, input } from '@angular/core';
import { PhoneReport, PhoneReportConnectivityInfo } from '../../../shared/models/phone-report.model';
import { DialogRef } from '../../../shared/services/modal.service';

@Component({
  standalone: false,
  selector: 'app-phone-report-connectivity-modal',
  templateUrl: './phone-report-connectivity-modal.component.html',
})
export class PhoneReportConnectivityModalComponent {
  readonly dialogRef = input<DialogRef>();
  readonly info = input<{
    report: PhoneReport;
    connectivityInfo: PhoneReportConnectivityInfo;
    isAdmin: boolean;
  } | null>(null);

  onCloseClick(): void {
    this.dialogRef().close(false);
  }
}
